import React from 'react';
import { Helmet } from 'react-helmet';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaExclamationTriangle, FaShieldAlt, FaFileContract, FaPhone, FaEnvelope } from 'react-icons/fa';
import '../Assets/Styles/Pages/refund_policy_page.css';

const RefundPolicy_page = () => {
  const refundSections = [
    {
      icon: <FaExclamationTriangle />,
      title: "All Sales Are Final",
      content: "All sales are final, and we do not offer refunds for the paid period of services already availed by the client. Complaints or dissatisfaction regarding the quality of services during the paid period shall not entitle the client to any refund or compensation."
    },
    {
      icon: <FaShieldAlt />,
      title: "SEBI Guidelines Compliance",
      content: "As per SEBI guidelines, if a client requests to cancel the subscription, a refund shall only be issued for the unused portion of the subscription period. The refund will be calculated on a pro-rata basis, deducting the charges for the services already availed, including applicable taxes and administrative fees. Once the refund request is approved, the refunded amount will be processed and credited within 09 to 15 business days to the original mode of payment."
    },
    {
      icon: <FaFileContract />,
      title: "No Refunds",
      content: "As the service involves digital content and market-sensitive information, no refund is issued once access has been provided. Please read all terms and understand the scope of service before proceeding with payment."
    },
    {
      icon: <FaExclamationTriangle />,
      title: "Market Risk Disclaimer",
      content: "Always remember Trading/Investment in Securities Markets are always subjected to Market Risk."
    },
    {
      icon: <FaShieldAlt />,
      title: "No Liability for Losses",
      content: "Any profits or losses resulting from our recommendations are solely the responsibility of the client. Trillion Stock Research shall not be liable for any trade losses incurred based on the research provided, and clients have no right to claim compensation for any losses under any circumstances."
    },
    {
      icon: <FaFileContract />,
      title: "Important Notice",
      content: "We request you to go through our website and read about the Disclaimer, Disclosure, and other terms before subscribing to my services. We do not offer any guaranteed returns or commit to guaranteed profits on our recommendations. We trade and invest in the stock market, where all investment and trading capital is subject to market risk."
    },
    
  ];

  return (
    <>
      <Helmet>
        <title>Refund Policy - Trillion Stock Research | Money Back Policy & Cancellation Terms</title>
        <meta name="description" content="Trillion Stock Research refund policy and cancellation terms. Understand our money-back policy, service cancellation procedures, and SEBI compliant refund guidelines." />
        <meta name="keywords" content="refund policy, money back policy, cancellation terms, Trillion Stock Research, SEBI refund guidelines, investment advisory refund" />
        <meta name="author" content="Trillion Stock Research" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.trillionstockresearch.com/refund" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Refund Policy - Trillion Stock Research" />
        <meta property="og:description" content="Refund policy and cancellation terms for investment advisory services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.trillionstockresearch.com/refund" />
        <meta property="og:image" content="https://www.trillionstockresearch.com/fav.png" />
        <meta property="og:site_name" content="Trillion Stock Research" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Refund Policy - Trillion Stock Research" />
        <meta name="twitter:description" content="Refund policy and cancellation terms for investment advisory services." />
        
        {/* Schema Markup */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Refund Policy",
            "description": "Refund policy and cancellation terms for Trillion Stock Research services",
            "url": "https://www.trillionstockresearch.com/refund",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Trillion Stock Research",
              "url": "https://www.trillionstockresearch.com"
            },
            "mainEntity": {
              "@type": "Article",
              "name": "Refund Policy",
              "description": "Refund policy and cancellation terms for Trillion Stock Research investment advisory services"
            }
          }
        `}</script>
      </Helmet>
      
      <div className="refund-policy-page">
        <AboutNav />
        <SEBISlider />
        
        <section className="refund-policy-hero">
          <div className="refund-policy-hero-content">
            <h1>Refund Policy</h1>
            <p>Important information about our refund and cancellation policies</p>
          </div>
        </section>

        <section className="refund-policy-container">
          <div className="refund-policy-intro">
            <h2>Refund Policy Overview</h2>
            <p>At Trillion Stock Research, we maintain clear and transparent refund policies to ensure all clients understand our terms before subscribing to our services. Please read this policy carefully before making any payments.</p>
          </div>

          <div className="refund-policy-grid">
            {refundSections.map((section, index) => (
              <div key={index} className="refund-policy-card">
                <div className="refund-policy-icon">
                  {section.icon}
                </div>
                <h3>{section.title}</h3>
                <p className="refund-policy-content">{section.content}</p>
              </div>
            ))}
          </div>

          <div className="refund-policy-contact">
            <h2>Contact Information</h2>
            <p>If you still have any query regarding our refund policy, please contact us:</p>
            <div className="contact-methods">
              <div className="contact-method">
                <FaPhone className="contact-icon" />
                <span>+919977555378</span>
              </div>
              <div className="contact-method">
                <FaEnvelope className="contact-icon" />
                <span>prachisharma33777@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="refund-policy-update">
            <h2>Last Updated</h2>
            <p>This refund policy is regularly reviewed and updated to ensure compliance with the latest regulations and best practices. The last update was made on March 15, 2024.</p>
          </div>
        </section>

        <section className="refund-policy-cta">
          <div className="cta-content">
            <h2>Have Questions About Our Refund Policy?</h2>
            <p>Our team is here to help you understand our policies and procedures.</p>
            <button className="cta-button">Contact Support</button>
          </div>
        </section>

        {/* Related Pages Section for SEO */}
        <section className="related-pages">
          <div className="related-pages-container">
            <h2>Related Legal Pages</h2>
            <div className="related-links">
              <a href="/terms" className="related-link">Terms & Conditions</a>
              <a href="/disclaimer" className="related-link">Disclaimer</a>
              <a href="/policy" className="related-link">Privacy Policy</a>
              <a href="/disclosure" className="related-link">SEBI Disclosure</a>
              <a href="/contact" className="related-link">Contact Us</a>
            </div>
          </div>
        </section>

        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  );
};

export default RefundPolicy_page;
